module.exports = __webpack_public_path__ + "r-v3/img/draw_none.73343374.svg";